import React, { useEffect, useState } from "react";
import style from "./style.module.css";
import { useNavigate } from "react-router";
import { loader } from "../../store/utilities";
import { getAllListingData } from "../../Api/commonApi";
import { SearchInput } from "../../components/SearchInput";

const Programme = () => {
  const [allCategoryInfo, setAllCategoryInfo] = useState([]);
  const [getAllData, setGetAllData] = useState([]);
  const navigate = useNavigate();

  const getAllDataFunction = async () => {
    loader.start();
    try {
      let response = await getAllListingData().then((res) => res.data.data);
      setGetAllData(response);
      setAllCategoryInfo(response)
    } catch (err) {
      console.error("Error fetching data", err);
    } finally {
      loader.stop();
    }
  };

  useEffect(() => {
    getAllDataFunction();
  }, []);

  // Filtered data based on search term
 
  const searchInfoList = (text) => {
    if (text.toLowerCase().trim().length !== 0) {
      const filteredInfo = allCategoryInfo.filter((res) => {
        return (
          res.category_name?.toLowerCase()?.includes(text)
          
        );
      });
      setGetAllData(filteredInfo);
      
    } else {
      setGetAllData(allCategoryInfo);
    }
  };

  return (
    <div className="mainContainer">
      <div className="d-flex justify-content-between">
        <div className={style.heading_section_programme}>Programme Sector</div>
        <div>
          <SearchInput onChange={(e) => searchInfoList(e.target.value)} />
        </div>
      </div>

      <div className={`${style.card_container} mt-5`}>
      {getAllData.map((data, index) => (
          <div
            key={index}
            className={`${style.card_style} `}
            onClick={() => {
              navigate(`/programmeList/${data._id}`);
            }}
          >
            <div>
              <img
                src={data?.image?.fileUrl}
                alt={data.title}
                width={100}
                height={100}
              />
            </div>
            <div className="category_name_style">{data.category_name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Programme;
